/**
 * 时分秒倒计时
 */
import React, { useEffect, useState } from 'react';

import DateJS, { parseSeconds2Hour } from '@/utils/date';

interface IProps {
  totalTime: number; // 总时间 秒
}

const Index: React.FC<IProps> = (props) => {
  const [leftTime, setLeftTime] = useState(0);
  const { totalTime } = props;

  useEffect(() => {
    let loopTimer;
    const startTime = DateJS();

    // 更新剩余时间
    const updateLeftTime = () => {
      let leftVal = totalTime - DateJS().diff(startTime, 'second');
      if (leftVal < 0) {
        leftVal = 0;
      }
      setLeftTime(leftVal);
      return leftVal;
    };

    // 倒计时
    const startTimeTicker = () => {
      loopTimer = setTimeout(() => {
        const leftVal = updateLeftTime();
        if (leftVal > 0) {
          startTimeTicker();
        }
      }, 1000);
    };

    // 剩余时间大于 0
    if (totalTime && totalTime > 0) {
      updateLeftTime();
      startTimeTicker();
    }
    return () => {
      clearTimeout(loopTimer);
    };
  }, [totalTime]);

  return <>{parseSeconds2Hour(leftTime)}</>;
};

export default Index;
